export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    title: that.$l('table_showTeamName') || '业务团队',
    field: 'teamName',
    width: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('table_custName') || '客户',
    field: 'custName',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('table_rateOfProgress') || '预算完成率',
    field: 'completionRate',
    width: 220,
    headerAlign: 'center',
    align: 'left',
    sortable: true,
    sortType: 'number',
    slots: { default: 'rateOfProgress' }
  },
  {
    title: that.$l('table_budgetAmount') || '预算总额',
    field: 'annualBudget',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'showBudget' }
  },
  {
    title: that.$l('table_salePriceAmount') || '订单金额',
    field: 'orderAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'showSales' }
  },
   {
    title: that.$l('table_label_budgetVariance') || '预算缺口',
    field: 'budgetVariance',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'showBudgetVariance' }
  },
  {
    title: that.$l('table_label_shippedAmount') || '已发运金额',
    field: 'shippedAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'showShippedAmount' }
  },
  {
    title: that.$l('table_label_unshippedAmount') || '未发运金额',
    field: 'unshippedAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'showUnshippedAmount' }
  }
]
